import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { RootState } from '../store';

const BASE_API = process.env.REACT_APP_BASE_API;

interface IAnyResponse {
  [key: string]: any;
}

interface IEmailPayload {
  subject: string;
  html: string;
}

export const emailSlice = createApi({
  reducerPath: 'email',
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_API
  }),

  endpoints: (builder) => ({
    sendEmail: builder.mutation<IAnyResponse, IEmailPayload>({
      query: (payload) => ({
        url: `mail`,
        method: 'POST',
        body: {
          subject: payload.subject,
          html: payload.html
        }
      })
    })
  })
});

export const { useSendEmailMutation } = emailSlice;
